import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  updateExistingProducts: {
    defaultMessage: 'Overwrite existing values for all fields included in the CSV',
    id: 'ufnzJT',
    description: 'Option to update existing products',
  },
  fulfillmentBarcodeWarningMessage: {
    defaultMessage: 'Modifying barcodes for products already labeled in Fulfilled by ShipStation warehouses may cause delays.',
    id: '31Q7oY',
    description: 'Warning message for fulfillment barcode field',
  },
});
